<template>
  <div v-loading="loading" class="eval-request">
    <search-input
      placeholder="Поиск ФИО"
      style="width: 300px"
      v-model="filters.search"
      @change="filtersChanged"
    >
    </search-input>
    <search-input
      placeholder="Поиск названию оценки 360"
      style="width: 300px; margin-left: 25px"
      v-model="filters.search_evaluation"
      @change="filtersChanged"
    >
    </search-input>
    <el-switch
      style="margin-left: 20px"
      v-model="filters.at_work"
      :active-value="1"
      :inactive-value="0"
      active-text="У меня в работе"
      @change="filtersChanged"
    >
    </el-switch>
    <div class="request-block">
      <el-table :data="requests" border>
        <el-table-column width="150" prop="user.persnum" label="Перс. №"></el-table-column>
        <el-table-column prop="user.full_name" label="ФИО"></el-table-column>
        <el-table-column prop="user.email" label="Email"></el-table-column>
        <el-table-column prop="evaluation.name" label="Название оценки 360"></el-table-column>
        <el-table-column width="300">
          <template v-slot="scope">
            <el-button
              size="mini"
              icon="fas fa-list-alt"
              @click="showRequests(scope.row.user.id, scope.row.evaluation.id)"
            >
              Определить коллег сотрудника
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <paginator
      :paginator.sync="paginator"
      use-router-query-param
      @page-changed="loadRequests"
    ></paginator>

    <eval-user-requests-dialog ref="showRequests" @load-requests="loadRequests"></eval-user-requests-dialog>
  </div>
</template>

<script>
import Paginator from "@/components/Paginator";
import SearchInput from "@/components/filters/SearchInput.vue";
import EvalUserRequestsDialog from "@/modules/evaluation/components/request/EvalUserRequestsDialog.vue";
import {paginator} from "@/mixins/paginator";

export default {
  name: "requests-component",
  components: {EvalUserRequestsDialog, Paginator, SearchInput},
  mixins: [paginator],
  data() {
    return {
      loading: false,
      requests: [],
      filters: {
        search: '',
        search_evaluation: '',
        at_work: 1,
      },
    }
  },
  beforeMount() {
    this.paginator.perPage = 10;
  },
  mounted() {
    this.loadRequests();
  },
  methods: {
    showRequests(userId, evaluationId) {
      this.$refs.showRequests.open(userId, evaluationId);
    },
    loadRequests() {
      this.loading = true;
      this.$api.evaluation.requestsSearch({
        ...this.filters,
        [this.paginator.param]: this.paginator.page,
        [this.paginator.paramPerPage]: this.paginator.perPage,
        expand: ['user', 'evaluation'].join(),
      })
        .then(({data, paginator}) => {
          this.requests = data.requests;
          this.paginatorFill(paginator);
        })
        .finally(() => {
          this.loading = false;
        })
    },
    filtersChanged() {
      this.loadRequests();
    }
  }
}
</script>

<style scoped lang="scss">
  .eval-request {
    .request-block {
      margin: 25px 0;
    }

    .table-router-link {
      text-decoration: none;
    }
  }
</style>